import { ApolloLink } from '@apollo/client/core'

import type { RepeatOptions } from '../../types'

import RequestRepeatFullfilledError from '../errors/RequestRepeatFullfilledError'
import RequestRepeatNotFullfilledError from '../errors/RequestRepeatNotFullfilled'

export const repeatableLink = new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    const { repeatCountReached, repeatOptions } = operation.getContext() as RepeatOptions

    if (repeatCountReached && repeatOptions?.errorOnNotFulfilled) {
      throw new RequestRepeatNotFullfilledError()
    }
    if (!repeatCountReached && repeatOptions?.repeatIf(response)) {
      throw new RequestRepeatFullfilledError()
    }

    return response
  }),
)
